import React from "react"

import logoIcon from "../../images/logoIcon.png"
import logo from "../../images/logo.png"
import logoWhite from "../../images/logo-white.png"
import logoIconWhite from "../../images/logoIconWhite.png"

import "./logo.scss"

var Logo = props => (
  <div className={`logo-component ${props.className || ""}`}>
    <div className="logo-icon">
      <img
        //src={props.white ? logoIconWhite : logoIcon}
        //src="https://drive.google.com/uc?export=view&id=16RHAJvxb_MaahwPl7hZUOa-dtlV4jas0"
        src="https://drive.google.com/uc?export=view&id=1Olkcqx7a7Q8MPzkwp75V6kljzysimceN"
        alt="Health Smart Holistic Health for Seniors logo icon"
      />
    </div>
    <div className="logo">
      <img
        //src={props.white ? logoWhite : logo}
        src="https://drive.google.com/uc?export=view&id=1Olkcqx7a7Q8MPzkwp75V6kljzysimceN"
        alt="Health Smart Holistic Health for Seniors logo"
      />
    </div>
  </div>
)

export default Logo
